import React, { useEffect } from "react";
import mapImage from "../assets/img/map.png"; // your map image

function Contact() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-gray-50">
      {/* Header */}
      <div className="flex justify-center py-10 lg:py-20 bg-gradient-to-r from-green-200 via-indigo-100 to-green-100 w-full bg-cover bg-no-repeat bg-bottom">
        <div className="flex mx-auto w-full max-w-screen-2xl px-3 sm:px-10">
          <div className="w-full flex justify-center flex-col relative">
            <h2 className="text-2xl md:text-4xl lg:text-5xl font-extrabold text-center text-gray-800 tracking-tight drop-shadow-md">
              Contact Us
            </h2>
          </div>
        </div>
      </div>

      {/* Contact Boxes */}
      <div className="bg-white">
        <div className="max-w-screen-2xl mx-auto lg:py-20 py-10 px-4 sm:px-10">
          <div className="grid md:grid-cols-2 gap-6 lg:grid-cols-2 xl:gap-8">
            {/* Location Box */}
            <div
              className="border p-10 rounded-lg text-center relative flex flex-col justify-center items-center"
              style={{
                backgroundImage: `url(${mapImage})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                height: "250px",
              }}
            >
              <a
                href="https://www.google.com/maps/search/?api=1&query=332/12+Barve+Nagar,+Ghatkopar,+Mumbai+400084,+Maharashtra(India)"
                target="_blank"
                rel="noopener noreferrer"
                className="absolute inset-0"
              ></a>
              <div className="bg-white bg-opacity-80 p-6 rounded-md z-10 relative">
                <h5 className="text-xl mb-2 font-bold">Location</h5>
                <p className="mb-0 text-base opacity-90 leading-7">
                  332/12, BARVE NAGAR, GHATKOPAR, MUMBAI 400084, MAHARASHTRA (INDIA)
                </p>
              </div>
            </div>

            {/* Email Box */}
            <div className="border p-10 rounded-lg text-center flex flex-col justify-center items-center">
              <span className="flex justify-center text-4xl text-emerald-500 mb-4">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth="2"
                  height="1em"
                  width="1em"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                  />
                </svg>
              </span>
              <h5 className="text-xl mb-2 font-bold">Email Us</h5>
              <p className="mb-0 text-base opacity-90 leading-7">
                <a href="mailto:ashtenglobal@gmail.com" className="text-blue-600">
                  ashtenglobal@gmail.com
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
